import { Api, ErrorService } from "@isocial-vue/blueprint";

const apiAuth = new Api("rtwp");
const apiNoAuth = new Api("rtwp", false);
const errorService = new ErrorService(
  "rtwp.form",
  new Map([
    [400, "002"],
    [401, "003"],
    [403, "004"],
    [404, "005"],
    [409, "006"],
    [500, "000"],
    [503, "000"],
  ]),
  "000",
  "001"
);

export const sendForm = async (data: string, auth = true): Promise<any> => {
  const endpoint = `form${!auth ? "u" : ""}`;
  const headers = { "Content-Type": "text/xml" };

  try {
    let response = null;
    if (auth) response = await apiAuth.post(endpoint, data, headers);
    else response = await apiNoAuth.post(endpoint, data, headers);
    return { statut: "success", response };
  } catch (error) {
    errorService.showError(error);
    return { status: "error", error };
  }
};
